import React from "react";
import { HighlightFilter } from "./HighlightFilter";
export const renderValue = (text, filter) => {
    if (!filter) {
        return text;
    }
    return React.createElement(HighlightFilter, { text: text, filter: filter });
};
